import React, { useEffect, useState } from 'react';
import api from '../api';
import './LokasyonDK.css';

const ROLE_LABELS = {
  yonetici: 'Yönetici', mudur: 'Müdür', tamirci: 'Teknisyen', muhasebe: 'Muhasebe', eksper: 'Eksper',
};

const LOCATIONS = {
  ikitelli: { name: 'İkitelli', address: 'İkitelli OSB, İstanbul', icon: 'IK' },
  hadimkoy: { name: 'Hadımköy', address: 'Hadımköy, İstanbul', icon: 'HK' },
};

function Icon({ name, size = 20 }) {
  const paths = {
    arrow: <path d="M5 12h14m-6-6 6 6-6 6" />,
    plus: <path d="M12 5v14M5 12h14" />,
    bell: <><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" /><path d="M10 21h4" /></>,
    service: <><path d="M5 20V10l7-6 7 6v10" /><path d="M9 20v-6h6v6M3 20h18" /></>,
    wrench: <path d="m14.7 6.3 3-3a4 4 0 0 1-5.2 5.2l-7.8 7.8a2 2 0 1 0 2.8 2.8l7.8-7.8a4 4 0 0 1 5.2-5.2l-3 3" />,
    receipt: <><path d="M6 3h12v18l-3-2-3 2-3-2-3 2V3Z" /><path d="M9 8h6M9 12h6M9 16h3" /></>,
    apps: <><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" /></>,
    document: <><path d="M6 3h8l4 4v14H6z" /><path d="M14 3v5h5M9 13h6M9 17h6" /></>,
    finance: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 10h18M7 15h2" /></>,
    users: <><circle cx="9" cy="8" r="3" /><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6M16 5.5a3 3 0 0 1 0 5M17 14c2.2.5 4 2.5 4 5" /></>,
    archive: <><path d="M3 7h18v14H3zM2 3h20v4H2z" /><path d="M10 11h4" /></>,
    shield: <path d="M12 3 4 6v5c0 5.1 3.4 8.8 8 10 4.6-1.2 8-4.9 8-10V6l-8-3Zm-3 9 2 2 4-4" />,
    settings: <><circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1-2.1 2.1-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.5v.2h-3v-.2a1.7 1.7 0 0 0-1-1.5 1.7 1.7 0 0 0-1.9.3l-.1.1-2.1-2.1.1-.1A1.7 1.7 0 0 0 7 15a1.7 1.7 0 0 0-1.5-1H5.3v-3h.2A1.7 1.7 0 0 0 7 10a1.7 1.7 0 0 0-.3-1.9l-.1-.1 2.1-2.1.1.1a1.7 1.7 0 0 0 1.9.3 1.7 1.7 0 0 0 1-1.5v-.2h3v.2a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.9-.3l.1-.1 2.1 2.1-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.5 1h.2v3h-.2a1.7 1.7 0 0 0-1.4 1Z" /></>,
    alert: <><path d="M12 3 2.6 20h18.8L12 3Z" /><path d="M12 9v4M12 17h.01" /></>,
  };
  return <svg className="dkd-icon" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">{paths[name] || paths.document}</svg>;
}

function ModuleCard({ title, detail, icon, tone = 'navy', onClick, badge, wide = false }) {
  return (
    <button type="button" className={`dkd-module dkd-module--${tone} ${wide ? 'dkd-module--wide' : ''}`} onClick={onClick}>
      <span className="dkd-module__icon"><Icon name={icon} size={22} /></span>
      <span className="dkd-module__text"><strong>{title}</strong><small>{detail}</small></span>
      {badge !== undefined && <span className="dkd-module__badge">{badge}</span>}
      <span className="dkd-module__arrow"><Icon name="arrow" size={17} /></span>
    </button>
  );
}

export default function Lokasyon({
  kullanici, canGor, onLokasyonSec, onMuhasebe, onArsiv, onSatinAlma, onFinans, onAdmin,
  onIhaleTakip, onTeklifler, onCari, onAcilParca, onSigortaBasvuru, onUygulamalar, onPazarlama, onIK, onCikis,
  previewStats, previewUrgent,
}) {
  const [istatistik, setIstatistik] = useState(previewStats || null);
  const [acilOzet, setAcilOzet] = useState(previewUrgent || { bekleyen_sayisi: 0, liste: [] });
  const [doviz, setDoviz] = useState(null);
  const [dovizDurum, setDovizDurum] = useState('yükleniyor');
  const [hesaplaAcik, setHesaplaAcik] = useState(false);
  const [hesapTutar, setHesapTutar] = useState('');
  const [hesapKaynak, setHesapKaynak] = useState('TL');
  const [hesapHedef, setHesapHedef] = useState('EUR');
  const gor = canGor || (() => true);
  const role = String(kullanici?.rol_kod || kullanici?.rol || '').trim().toLocaleLowerCase('tr-TR');
  const isEksper = role === 'eksper';

  const availableLocations = () => {
    if (!gor('lokasyon')) return [];
    if (gor('lokasyon_tumu')) return ['ikitelli', 'hadimkoy'];
    return [String(kullanici?.lokasyon || '').toLocaleLowerCase('tr-TR')].filter((key) => LOCATIONS[key]);
  };

  useEffect(() => {
    if (previewStats) return undefined;
    const locs = availableLocations();
    const kapaliMi = (durum) => ['kapatldi', 'kapatildi'].includes(String(durum || '').toLocaleLowerCase('tr-TR'));

    const load = async () => {
      try {
        const urgent = await api.get('/acil-siparisler/ozet').catch(() => ({ data: { bekleyen_sayisi: 0, liste: [] } }));
        setAcilOzet(urgent?.data || { bekleyen_sayisi: 0, liste: [] });

        if (!isEksper) {
          const result = await api.get('/araclar/istatistik');
          setIstatistik(result?.data || null);
          return;
        }

        const stats = { ikitelli: {}, hadimkoy: {} };
        await Promise.all(locs.map(async (lokasyon) => {
          const { data } = await api.get(`/araclar/liste?lokasyon=${encodeURIComponent(lokasyon)}`);
          const list = Array.isArray(data) ? data : [];
          const sigortaBekleyen = list.filter((item) => String(item?.sigorta_basvuru_durum || '').toLocaleLowerCase('tr-TR') === 'bekliyor').length;
          stats[lokasyon] = {
            aktif: list.filter((item) => !kapaliMi(item?.durum)).length,
            kapali: list.filter((item) => kapaliMi(item?.durum)).length,
            sigorta_basvuru_bekleyen: sigortaBekleyen,
          };
        }));
        setIstatistik(stats);
      } catch {
        setIstatistik(null);
      }
    };
    load();
    return undefined;
  }, [isEksper, kullanici?.lokasyon, previewStats]);

  useEffect(() => {
    let aktif = true;
    const yukle = async () => {
      try {
        const { data } = await api.get('/stok-kartlari/kur/guncel');
        if (!aktif) return;
        setDoviz(data || null);
        setDovizDurum('hazır');
      } catch {
        if (!aktif) return;
        setDovizDurum('hata');
      }
    };
    yukle();
    const zamanlayici = window.setInterval(yukle, 30 * 60 * 1000);
    return () => { aktif = false; window.clearInterval(zamanlayici); };
  }, []);

  const locations = availableLocations();
  const activeCount = (lokasyon) => Number(istatistik?.[lokasyon]?.aktif || 0);
  const closedCount = (lokasyon) => Number(istatistik?.[lokasyon]?.kapali || 0);
  const insurancePending = locations.reduce((total, lokasyon) => total + Number(istatistik?.[lokasyon]?.sigorta_basvuru_bekleyen ?? istatistik?.[lokasyon]?.sigorta_basvuru ?? 0), 0);
  const totalActive = locations.reduce((total, lokasyon) => total + activeCount(lokasyon), 0);
  const totalClosed = locations.reduce((total, lokasyon) => total + closedCount(lokasyon), 0);
  const canSeeCari = !isEksper && (role === 'yonetici' || gor('lokasyon') || gor('muhasebe') || gor('finans') || gor('arsiv'));
  const firstName = (kullanici?.ad_soyad || kullanici?.kullanici_adi || 'Kullanıcı').trim().split(/\s+/)[0];
  const initial = firstName.slice(0, 1).toLocaleUpperCase('tr-TR');
  const today = new Intl.DateTimeFormat('tr-TR', { weekday: 'long', day: 'numeric', month: 'long' }).format(new Date());
  // Kur kartında iki basamak gösterilir. Finans ekranındaki değerler aynı
  // canlı TCMB satış kurundan gelir; ekranda üçüncü/dördüncü basamak yoktur.
  const formatKur = (value) => {
    const number = Number(value || 0);
    return (Math.trunc(number * 100) / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  const kurZaman = doviz?.fetchedAt ? new Intl.DateTimeFormat('tr-TR', { hour: '2-digit', minute: '2-digit' }).format(new Date(doviz.fetchedAt)) : '';
  const usdKuru = Number(doviz?.usd || 0);
  const eurKuru = Number(doviz?.eur || 0);
  const hesapKurlari = { TL: 1, EUR: eurKuru, USD: usdKuru };
  const parseTutar = (value) => {
    const raw = String(value || '').trim().replace(/\s/g, '');
    if (!raw) return 0;
    // 15.641,89 ve 15641.89 gibi iki yaygın giriş biçimini destekler.
    const normalized = raw.includes(',') ? raw.replace(/\./g, '').replace(',', '.') : raw;
    return Number(normalized) || 0;
  };
  const hesaplananTutar = (() => {
    const tutar = parseTutar(hesapTutar);
    const kaynakKur = hesapKurlari[hesapKaynak];
    const hedefKur = hesapKurlari[hesapHedef];
    if (!tutar || !kaynakKur || !hedefKur) return null;
    return (tutar * kaynakKur) / hedefKur;
  })();

  return (
    <main className="dkd-dashboard">
      <div className="dkd-dashboard__backdrop" />
      <header className="dkd-topbar">
        <div className="dkd-topbar__inner">
          <div className="dkd-brand"><img src="/web-ios-logo.svg" alt="OtoFlow" /><span>Ağır Vasıta Servis Yönetimi</span></div>
          <div className="dkd-profile">
            <div className="dkd-profile__meta"><strong>{kullanici?.ad_soyad || kullanici?.kullanici_adi}</strong><small>{ROLE_LABELS[role] || kullanici?.rol || 'Kullanıcı'}</small></div>
            <span className="dkd-avatar">{initial}</span>
            {(gor('kullanicilar') || role === 'yonetici') && <button type="button" className="dkd-icon-button" onClick={onAdmin} title="Yönetim"><Icon name="settings" size={18} /></button>}
            <button type="button" className="dkd-exit" onClick={onCikis}>Çıkış</button>
          </div>
        </div>
      </header>

      <section className="dkd-shell">
        <section className="dkd-hero">
          <div className="dkd-hero__copy">
            <span className="dkd-eyebrow"><span className="dkd-dot" /> OPERASYON MERKEZİ</span>
            <h1>Hoş geldin, <em>{firstName}</em>.</h1>
            <p>Servis operasyonunuzu tek noktadan, daha net ve hızlı yönetin.</p>
            <div className="dkd-hero__actions">
              {locations[0] && <button type="button" className="dkd-primary" onClick={() => onLokasyonSec(locations[0])}>Araçlara Git <Icon name="arrow" size={17} /></button>}
              <span className="dkd-date">{today}</span>
            </div>
          </div>
          <div className="dkd-hero__side">
            <div className="dkd-hero__fx" aria-live="polite">
              <div className="dkd-hero__fx-head"><span>Güncel döviz kuru</span><small>{dovizDurum === 'hata' ? 'Tekrar denenecek' : (kurZaman ? `TCMB · ${kurZaman}` : 'TCMB satış')}</small></div>
              <div className="dkd-hero__fx-rates">
                <div><span>USD</span><strong>{doviz?.usd ? formatKur(doviz.usd) : '—'}<i>₺</i></strong></div>
                <div><span>EUR</span><strong>{doviz?.eur ? formatKur(doviz.eur) : '—'}<i>₺</i></strong></div>
              </div>
              <button type="button" className="dkd-hero__calculator-toggle" onClick={() => setHesaplaAcik((open) => !open)} aria-expanded={hesaplaAcik}>⌘ Hesapla</button>
              {hesaplaAcik && <div className="dkd-currency-calculator" aria-label="Döviz hesaplama">
                <label>Para tutarı<input inputMode="decimal" value={hesapTutar} onChange={(event) => setHesapTutar(event.target.value)} placeholder="Örn. 15.641,89" /></label>
                <div className="dkd-currency-calculator__selects">
                  <label>Şu anki para birimi<select value={hesapKaynak} onChange={(event) => setHesapKaynak(event.target.value)}><option value="TL">Türk lirası (TL)</option><option value="EUR">Euro (EUR)</option><option value="USD">Dolar (USD)</option></select></label>
                  <label>Çevrilecek para birimi<select value={hesapHedef} onChange={(event) => setHesapHedef(event.target.value)}><option value="EUR">Euro (EUR)</option><option value="TL">Türk lirası (TL)</option><option value="USD">Dolar (USD)</option></select></label>
                </div>
                <output className="dkd-currency-calculator__result">{hesaplananTutar === null ? (hesapKaynak === 'USD' || hesapHedef === 'USD' ? 'USD kuru yükleniyor…' : 'Tutar girin') : <><strong>{hesaplananTutar.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong> <span>{hesapHedef}</span></>}</output>
                <small>Hesaplama canlı TCMB satış kuru ile yapılır.</small>
              </div>}
            </div>
            <div className="dkd-hero__metrics">
              <div><span>Aktif araç</span><strong>{totalActive}</strong></div>
              <div><span>Kapanan dosya</span><strong>{totalClosed}</strong></div>
              <div><span>Tanımlı lokasyon</span><strong>{locations.length}</strong></div>
            </div>
          </div>
        </section>

        <section className="dkd-section">
          <div className="dkd-section__head"><div><span className="dkd-eyebrow dkd-eyebrow--dark">LOKASYONLAR</span><h2>Servis seçin</h2></div><span>{locations.length} erişilebilir lokasyon</span></div>
          {locations.length ? <div className="dkd-location-grid">{locations.map((key) => {
            const item = LOCATIONS[key];
            return <button type="button" key={key} className="dkd-location" onClick={() => onLokasyonSec(key)}>
              <span className="dkd-location__mark">{item.icon}</span>
              <span className="dkd-location__body"><strong>{item.name}</strong><small>{item.address}</small><span className="dkd-location__counts"><b>{activeCount(key)} <i>aktif</i></b><b>{closedCount(key)} <i>kapanan</i></b></span></span>
              <span className="dkd-location__go"><Icon name="arrow" size={19} /></span>
            </button>;
          })}</div> : <div className="dkd-empty">Bu alan için görüntüleme yetkiniz bulunmuyor.</div>}
        </section>

        {gor('gelen_siparis_gor') && Number(acilOzet?.bekleyen_sayisi || 0) > 0 && (
          <button type="button" className="dkd-alert" onClick={() => onSatinAlma?.('gelen_siparisler')}>
            <span><Icon name="alert" size={20} /></span>
            <p><strong>{acilOzet.bekleyen_sayisi} acil parça siparişi bekliyor</strong><small>Gelen siparişleri incelemek için açın.</small></p>
            <Icon name="arrow" size={18} />
          </button>
        )}

        <section className="dkd-section dkd-section--modules">
          <div className="dkd-section__head"><div><span className="dkd-eyebrow dkd-eyebrow--dark">HIZLI ERİŞİM</span><h2>İşlemler</h2></div><span>Yetkiniz dahilindeki modüller</span></div>
          <div className="dkd-module-grid">
            {(gor('siparis_ver') || gor('satinalma') || role === 'yonetici') && <ModuleCard title="Acil Parça" detail="Hızlı talep ve tedarikçi bildirimi" icon="bell" tone="red" onClick={onAcilParca} />}
            {gor('satinalma') && <ModuleCard title="Satın Alma" detail="Tedarikçiler ve parça listeleri" icon="receipt" tone="blue" onClick={onSatinAlma} />}
            {(gor('teklif_gor') || gor('teklif_ver') || role === 'yonetici') && <ModuleCard title="Raporlar ve Belgeler" detail="Teklif, rapor ve PDF işlemleri" icon="document" tone="green" onClick={onTeklifler} />}
            {role === 'yonetici' && <ModuleCard title="Sigorta Başvuru" detail="Kasko ve trafik dosya takibi" icon="shield" tone="mint" onClick={onSigortaBasvuru} badge={insurancePending} />}
            {gor('ihale') && <ModuleCard title="İhale Takip" detail="Aktif ihale ve parça süreçleri" icon="service" tone="orange" onClick={onIhaleTakip} />}
            {gor('muhasebe') && <ModuleCard title="Muhasebe" detail="Fatura ve cari işlem merkezi" icon="receipt" tone="purple" onClick={onMuhasebe} />}
            {gor('finans') && <ModuleCard title="Finans" detail="Havale kayıtları ve filtreleme" icon="finance" tone="blue" onClick={onFinans} />}
            {role === 'yonetici' && <ModuleCard title="İnsan Kaynakları" detail="İş ilanları, adaylar ve PDF CV" icon="users" tone="teal" onClick={onIK} />}
            {gor('pazarlama') && <ModuleCard title="Pazarlama" detail="Hedef firma, kampanya ve SEO takibi" icon="users" tone="orange" onClick={onPazarlama} />}
            {canSeeCari && <ModuleCard title="Müşteriler" detail="Firma kartları ve filo listeleri" icon="users" tone="teal" onClick={onCari} />}
            {gor('arsiv') && <ModuleCard title="Arşiv" detail="Arşivlenmiş araç kayıtları" icon="archive" tone="slate" onClick={onArsiv} />}
            <ModuleCard title="Uygulamalar" detail="PhotoCraft, PDF, belge ve tablo araçları" icon="apps" tone="blue" onClick={onUygulamalar} />
          </div>
        </section>
      </section>
    </main>
  );
}
